
<div :class="jel_getClassObject(content)">
  <div v-if="produitCollection" class="themeFonce background-entete">
    <b-row align-h="between" class="p-0 m-0">
      <!-- TODO: Avec un b-row on s'attend à un b-col. À réviser -->
      <div class="p-0 m-0">
        <div class="d-lg-none">
          <b-button
            class="bouton-retour rounded-0 p-0 m-0 border-0 shadow-none"
            @click="jel_traiterRetour()"
          >
            <svg-icon
              class="svg-icone-retour rotation180"
              icon-name="fleche-droite-mini-lien"
            ></svg-icon>
          </b-button>
        </div>
        <LienRetour class="d-none d-lg-flex pt-1 pl-1" :content="{ appareil: 'tous' }" />
      </div>
      <div class="d-flex justify-content-end">
        <svg-icon class="svg-icone" icon-name="icone-loop" />
        <div>
          <b-form-input
            v-model="filtre.titre"
            class="rounded-0 border-0 body-5 form-control"
            :class="[!isFiltre ? 'recherche-sans-texte' : 'recherche']"
            debounce="500"
            :placeholder="$t('messageComponent.recherche')"
          ></b-form-input>
        </div>

        <b-button
          v-if="isFiltre"
          class="rounded-0 p-0 m-0 border-0 shadow-none"
          @click="resetFiltre()"
        >
          <svg-icon class="svg-icone" icon-name="icone-fermer-recherche" />
        </b-button>
      </div>
    </b-row>
    <b-row align-h="between" class="mr-2 mr-md-3">
      <b-col :cols="$isMobile() ? 9 : 12">
        <h2
          :class="description ? 'titre-entete-avec-description' : 'titre-entete'"
          v-html="titre"
        />
        <p v-if="description" class="texte-entete graphik_regular" v-html="`${description}`" />
      </b-col>
    </b-row>
  </div>
  <div
    v-if="isConsentementRequis && !isConsentant"
    class="mw-100 container-produit-collection-without-consent container-fluid"
  >
    <div class="pl-2 py-2 col texte-consentement" v-html="getMessageConsentement()" />
  </div>
  <b-container
    v-else-if="produitCollection && arrayProduitFiltre"
    fluid
    class="mw-100 container-produit-collection"
  >
    <b-row align-h="between">
      <b-col class="ml-2 my-2 resultats">
        {{
          arrayProduitFiltre.length > 1
            ? $tc('messageComponent.resultat', arrayProduitFiltre.length)
            : $tc('messageComponent.resultat', 1, { n: arrayProduitFiltre.length })
        }}
      </b-col>
      <!-- <p class="d-flex justify-content-end mr-5">{{ $tc('messageComponent.trierPar') }}</p> -->
    </b-row>
    <b-row id="collectionProduits" class="collection-produits mw-100 m-0 mt-0">
      <b-col
        v-for="produit in getArrayProduitFiltre"
        :key="produit['@id']"
        class="col-12 col-sm-6 col-md-4 col-xxl-3 p-1"
      >
        <mq-layout mq="xs">
          <MediaImageLogoProduitCasinoLarge
            :content="{ produit: produit }"
            class="carte-logo-fixe liste-1-colonne"
          />
        </mq-layout>
        <mq-layout mq="sm+">
          <CarteProduitCasino
            :content="{ produit: produit, formatCarte: '5x6', isCollectionCasino: true }"
          />
        </mq-layout>
      </b-col>
    </b-row>
    <b-row v-if="arrayProduitFiltre.length !== 0" class="my-2">
      <b-col class="mt-1 text-center jeux-affiche">
        {{
          arrayProduitFiltre.length == 1
            ? $tc('messageComponent.jeuxAffiches', 1, {
                nMin: nbProduitsAffiche,
                nMax: arrayProduitFiltre.length,
              })
            : $tc('messageComponent.jeuxAffiches', 2, {
                nMin: nbProduitsAffiche,
                nMax: arrayProduitFiltre.length,
              })
        }}
      </b-col>
    </b-row>
    <b-row class="pb-3">
      <b-col class="d-flex justify-content-center">
        <button
          v-if="nbProduitsAffiche < arrayProduitFiltre.length"
          class="voir-plus px-0 lienAsset"
          @click="augmenterProduitsAffiche()"
        >
          {{ $tc('messageComponent.voirPlus') }}
        </button>
      </b-col>
    </b-row>
  </b-container>
  <div v-else>
    <div class="d-flex justify-content-center vh-100">
      <b-spinner
        variant="primary"
        class="align-self-center"
        type="grow"
        :label="$t('chargement')"
      />
    </div>
  </div>
</div>
